export interface IsaTransferAccount {
    accountStatus?: string;
    id: string;
    product?: {
        productType?: string;
    };
}

const fundingOpenStatuses = ['', 'Active', 'FundingOpen'];

export const isEligibleIsaTransferDestination = (account: IsaTransferAccount) => (
    (account.product?.productType === 'FIXED_RATE_CASH_ISA' ||
     account.product?.productType === 'INSTANT_ACCESS_CASH_ISA') &&
    fundingOpenStatuses.includes(account.accountStatus ?? '')
);
